import { ClientLogger } from './client';
import type { ILogger } from './types';

const getLogger = (): ILogger => {
    if (typeof window === 'undefined') {
        const { ServerLogger } = require('./server');
        return new ServerLogger();
    }
    return new ClientLogger();
};

export const logger = getLogger();
